import { render, staticRenderFns } from "./BulkInventoryItemHeader.vue?vue&type=template&id=d72a694e&scoped=true"
import script from "./BulkInventoryItemHeader.vue?vue&type=script&lang=ts"
export * from "./BulkInventoryItemHeader.vue?vue&type=script&lang=ts"
import style0 from "./BulkInventoryItemHeader.vue?vue&type=style&index=0&id=d72a694e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a694e",
  null
  
)

export default component.exports